import { TextField, TextFieldProps } from "@mui/material";
import React, { ChangeEvent, useEffect, useState } from "react";

interface LicensePlateInputProps
    extends Omit<TextFieldProps, "onChange" | "value"> {
    value?: string;
    onChange?: (value: string) => void;
}

const LicensePlateInput: React.FC<LicensePlateInputProps> = ({
    value = "",
    onChange,
    ...props
}) => {
    const [inputValue, setInputValue] = useState(value);
    // const [error, setError] = useState<string>("");

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    // Indonesian license plate regions

    const formatLicensePlate = (input: string): string => {
        // Remove all non-alphanumeric characters
        const cleaned = input.replace(/[^A-Za-z0-9]/g, "").toUpperCase();

        if (cleaned.length === 0) return "";

        // Extract region (1-2 letters at start)
        const regionMatch = cleaned.match(/^[A-Z]{1,2}/);
        if (!regionMatch) return cleaned;

        const region = regionMatch[0];
        const remaining = cleaned.slice(region.length);

        if (remaining.length === 0) {
            return region;
        }

        // Extract numbers (up to 4 digits after region)
        const numberMatch = remaining.match(/^\d{1,4}/);
        if (!numberMatch) {
            // If no numbers found but we have remaining chars, it might be invalid input
            return region;
        }

        const numbers = numberMatch[0];
        const letters = remaining.slice(numbers.length).slice(0, 3); // Max 3 letters

        if (letters.length > 0) {
            return `${region} ${numbers} ${letters}`;
        } else {
            return `${region} ${numbers}`;
        }
    };

    // const validateLicensePlate = (plate: string): string => {
    //     if (!plate) return "";

    //     // Check full format: X(X) NNNN XX(X)
    //     const fullFormatRegex = /^[A-Z]{1,2}\s\d{1,4}\s[A-Z]{1,3}$/;
    //     const partialFormatRegex = /^[A-Z]{1,2}(\s\d{1,4})?$/;

    //     if (fullFormatRegex.test(plate)) {
    //         const parts = plate.split(" ");
    //         const region = parts[0];
    //         const number = parseInt(parts[1]);
    //         const letters = parts[2];

    //         if (!validRegions.includes(region)) {
    //             return "Invalid region code";
    //         }
    //         if (number < 1 || number > 9999) {
    //             return "Number must be between 1-9999";
    //         }
    //         if (letters.length < 1 || letters.length > 3) {
    //             return "Letter suffix must be 1-3 characters";
    //         }
    //         return "";
    //     } else if (partialFormatRegex.test(plate)) {
    //         const region = plate.split(" ")[0];
    //         if (!validRegions.includes(region)) {
    //             return "Invalid region code";
    //         }
    //         return "";
    //     } else if (plate.length > 0) {
    //         return "Invalid license plate format";
    //     }

    //     return "";
    // };

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const rawValue = e.target.value;
        const formatted = formatLicensePlate(rawValue);
        // const validationError = validateLicensePlate(formatted);

        setInputValue(formatted);
        // setError(validationError);

        if (onChange) {
            onChange(formatted);
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        // Allow navigation keys, backspace, delete
        if (
            e.key === "Backspace" ||
            e.key === "Delete" ||
            e.key === "Tab" ||
            e.key === "ArrowLeft" ||
            e.key === "ArrowRight" ||
            e.key === "Home" ||
            e.key === "End"
        ) {
            return;
        }

        // Only allow alphanumeric characters
        if (!/[A-Za-z0-9]/.test(e.key)) {
            e.preventDefault();
        }
    };

    return (
        <TextField
            {...props}
            variant="outlined"
            value={inputValue}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            // error={!!error}
            // helperText={
            //     error ||
            //     "Format: Region Code + Numbers + Letters (e.g., B 1234 ABC)"
            // }
            placeholder="H 1234 ABC"
            inputProps={{
                maxLength: 11,
                style: { textTransform: "uppercase" },
            }}
        />
    );
};

export default LicensePlateInput;

// Usage example:
// const App = () => {
//   const [licensePlate, setLicensePlate] = useState('');
//
//   return (
//     <LicensePlateInput
//       label="License Plate"
//       value={licensePlate}
//       onChange={setLicensePlate}
//       fullWidth
//       margin="normal"
//     />
//   );
// };
